import React, { useEffect } from "react";
import { compose } from "redux";
import connectActions from "fantastic/lib/connectActions";
import actions from "fantastic/actions";
import jquery from 'jquery';
import geocomplete from 'geocomplete';
import SingleStringSetting from "fantastic/components/common/controls/SingleStringSetting";
import settingable from "fantastic/components/hoc/settingable";

const MapSettings = ({
  selected,
  update,
  uploadMap,
  selectedNode: { id, src, href, alt }
}) => {

  useEffect(() => {
    jquery('.geo-complete:not(.init)').geocomplete().bind("geocode:result", (e, result) => {
      updateMap(result)
    }).addClass('init')
  }, [])

  const generateLink = (geo) => {
    let lat = geo.location.lat
    let lng = geo.location.lng
    return `https://yandex.ru/maps/?pt=${lng},${lat}&z=17.51&l=map`
  }

  const updateMap = (result) => {
    let geo = JSON.parse(JSON.stringify(result.geometry))
    let formattedAddress = result.formatted_address

    update(selected, {
      ['alt']: formattedAddress,
      ['href']: generateLink(geo)
    })
    uploadMap(id, JSON.stringify(geo.location))
  }

  const autocompleteChanger = (e) => {
    if (e.target.value.length) {
      update(selected, { ['alt']: e.target.value });
    } else {
      update(selected, {
        ['alt']: e.target.value,
        ['src']: "",
        ['href']: ""
      });
    }

    return e.target.value
  };

  const onChange = (field) => {
    return (value) => {
      update(selected, { [field]: value });
    }
  };

  return (
    <>
      <div className="form-group">
        <label>{ i18n.t('address') }</label>
        <input
          type="text"
          className="form-control fantastic-form-control geo-complete"
          onChange={autocompleteChanger}
          placeholder={ i18n.t('address_enter') }
          value={alt}
        />
      </div>

      <SingleStringSetting value={href} onChange={onChange('href')} label={i18n.t('link')} />
    </>
  );
};

export default compose(
  settingable("padding", "visibility"),
  connectActions({
    update: actions.updateNode,
    uploadMap: actions.uploadMap
  })
)(MapSettings);
